export default "__VITE_ASSET__DNXRI3Uq__"